import React, { useState } from "react";
import { Table, Pagination, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  useGetOrderListQuery,
  useUpdateOrderStatusMutation,
} from "../../Services/OrdersAPI";

function Products() {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const { data: ordersData, isLoading, error } = useGetOrderListQuery();

  const filteredData =
    ordersData?.data?.orders?.data?.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    ) || [];

  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage)); // Ensure at least 1 page

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [orderStatusMap, setOrderStatusMap] = useState({});
  const [updateOrderStatus] = useUpdateOrderStatusMutation(); // RTK Query mutation

  // Function to handle order & payment status change
  const handleStatusChange = async (
    order_main_id,
    order_id,
    newOrderStatus,
    newPaymentStatus
  ) => {
    setOrderStatusMap((prev) => ({
      ...prev,
      [order_id]: {
        order_status: newOrderStatus,
        payment_status: newPaymentStatus,
      },
    }));

    // Call API to update both statuses
    try {
      let formData = {
        order_main_id: order_main_id,
        order_id: order_id,
        order_status: newOrderStatus,
        payment_status: newPaymentStatus,
      };
      await updateOrderStatus(formData).unwrap();
      alert("Order and payment status updated successfully!");
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  if (isLoading) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>
      <h3>Orders</h3>
      <div className="content-wrapper">
        <div>
          {/* Search Input */}
          <div className="row justify-flex-end search-box">
            <div className="col-md-6 col-sm-12 col-lg-6 d-flex justify-end gap-10">
              <InputGroup className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Payment Status</th>
                  <th>Order Status</th>
                  <th>Order Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems?.map((item) => (
                  <tr key={item.id}>
                    <td>{item.order_id}</td>
                    <td>{item.first_name + " " + item.last_name}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>
                    <td>
                      <select
                        value={
                          orderStatusMap[item.order_id]?.payment_status ||
                          item.payment_status
                        }
                        onChange={(e) =>
                          handleStatusChange(
                            item.id,
                            item.order_id,
                            orderStatusMap[item.order_id]?.order_status ||
                              item.order_status,
                            e.target.value
                          )
                        }
                      >
                        <option value="pending">Pending</option>
                        <option value="paid">Paid</option>
                        <option value="failed">Failed</option>
                        <option value="refunded">Refunded</option>
                      </select>
                    </td>
                    <td>
                      <select
                        value={
                          orderStatusMap[item.order_id]?.order_status ||
                          item.order_status
                        }
                        onChange={(e) =>
                          handleStatusChange(
                            item.id,
                            item.order_id,
                            e.target.value,
                            orderStatusMap[item.order_id]?.payment_status ||
                              item.payment_status
                          )
                        }
                      >
                        <option value="order_placed">Order Placed</option>
                        <option value="processing">Processing</option>
                        <option value="shipped">Shipped</option>
                        <option value="delivered">Delivered</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </td>
                    <td>{item.created_at}</td>
                    <td>
                      <Link to={`/view-order/${item.id}/${item.order_id}`}>
                        <FontAwesomeIcon
                          icon={faEye}
                          className=" mx-2"
                          style={{ cursor: "pointer" }}
                        />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Pagination */}
          <Pagination className="d-flex justify-flex-end">
            {totalPages > 1 && (
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
            )}
            {totalPages > 1 && (
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
            )}
            {totalPages > 1 &&
              [...Array(totalPages)]?.map((_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}

            {totalPages > 1 && (
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            )}
            {totalPages > 1 && (
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            )}
          </Pagination>
        </div>
      </div>
    </div>
  );
}

export default Products;
